import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { number, bool, func } from 'prop-types';
import OfferControlsModal from '../../components/Offer/OfferControlsModal';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

const propTypes = {
  offerId: number.isRequired,
  onRequestOfferAccess: func.isRequired,
  onRefuseOfferAccess: func.isRequired,
  onFlowCreate: func.isRequired,
  isMy: bool.isRequired,
  hasAccess: bool.isRequired,
  hasPromo: bool.isRequired,
  toggleControlsModal: func.isRequired,
};

const defaultProps = {
  isMy: false,
  hasAccess: false,
  hasPromo: false,
};

const OfferCardControls = ({
  theme,
  offerId,
  isMy,
  hasPromo,
  onRequestOfferAccess,
  onRefuseOfferAccess,
  onFlowCreate,
  openControlsModal,
  toggleControlsModal,
}) => (
  <>
    <button className="offer-controls-mob-btn" onClick={toggleControlsModal}>
      <SVG
        className="item-bin-icon"
        src={`${STATIC_PATH}/img/action-icons/menu-controls-icon.svg`}
        height="21"
        width="21"
        cacheRequests
      />
    </button>
    <ul className="offer-controls list-inline">
      {isMy ? (
        <>
          <li className="list-inline-item">
            <Button
              type="button"
              color="danger"
              outline
              onClick={onRefuseOfferAccess.bind(null, offerId)}
            >
              <FormattedMessage id="offer.buttons.remove-offer" defaultMessage="Remove offer" />
            </Button>
          </li>
          <li className="list-inline-item">
            <Button color="primary" onClick={onFlowCreate.bind(null, offerId)}>
              <FormattedMessage id="offer.buttons.create-flow" defaultMessage="Create Flow" />
            </Button>
          </li>
        </>
      ) : (
        <li className="list-inline-item">
          <Button type="button" color="primary" onClick={onRequestOfferAccess.bind(null, offerId)}>
            <FormattedMessage id="offer.buttons.activate-offer" defaultMessage="Activate" />
          </Button>
        </li>
      )}

      {hasPromo && (
        <li className="list-inline-item">
          <Button color="light" tag={Link} to={`/offers/${offerId}/files`}>
            <FormattedMessage id="offer.buttons.promo-files" defaultMessage="Promo files" />
          </Button>
        </li>
      )}
    </ul>

    <OfferControlsModal
      toggle={toggleControlsModal}
      open={openControlsModal}
      offerId={offerId}
      isMy={isMy}
      onRefuseOfferAccess={onRefuseOfferAccess}
      onRequestOfferAccess={onRequestOfferAccess}
      onFlowCreate={onFlowCreate}
      hasPromo={hasPromo}
    />
  </>
);

OfferCardControls.propTypes = propTypes;
OfferCardControls.defaultProps = defaultProps;

export default OfferCardControls;
